import { useAtomValue } from 'jotai';
import { LapsView } from './LapsView.tsx';
import RaceTime from './RaceTime.tsx';
import { currentRaceAtom, lastRaceAtom } from './race-atoms.ts';
import { NextRaceCompact } from './NextRaceCompact.tsx';
import { nextRaceEntriesAtom } from './next-race-entries.ts';
import { RaceNumber } from './RaceNumber.tsx';
import { FinalsRacePanel } from './FinalsRacePanel.tsx';

export function RacesContainer() {
	const currentRace = useAtomValue(currentRaceAtom);
	const lastRace = useAtomValue(lastRaceAtom);
	const nextRaces = useAtomValue(nextRaceEntriesAtom);

	// Hide current race when there's only one race and it matches the last race
	const showCurrentRace = !!currentRace && !(lastRace && currentRace.id === lastRace.id);

	return (
		<div className='races-container'>
			<FinalsRacePanel />
			{lastRace && (
				<div className='race-box last-race'>
					<div className='race-header'>
						<h3>Last Race</h3>
						<RaceNumber raceId={lastRace.id} />
					</div>
					<LapsView
						key={lastRace.id}
						raceId={lastRace.id}
					/>
				</div>
			)}
			{showCurrentRace && (
				<div className='race-box current-race'>
					<div className='race-header'>
						<h3>Current Race</h3>
						<RaceNumber raceId={currentRace.id} />
						<div className='race-timer'>
							<RaceTime />
						</div>
					</div>
					<LapsView
						key={currentRace.id}
						raceId={currentRace.id}
					/>
				</div>
			)}
			<div className='race-box next-races'>
				<div className='race-header'>
					<h3>Next Races</h3>
				</div>
				{nextRaces.map((entry) => (
					<NextRaceCompact
						key={entry.raceId}
						entry={entry}
					/>
				))}
			</div>
		</div>
	);
}
